/* Excellence des Cimes · effets chalet (Webmind) */
(function () {
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var tasks = [], ticking = false;
  function onScroll(fn) { tasks.push(fn); }
  function run() { ticking = false; for (var i = 0; i < tasks.length; i++) tasks[i](); }
  d.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(run); } }, { passive: true, capture: true });
  w.addEventListener('resize', run);

  /* 1. Apparitions au défilement */
  if (!reduce && !design && 'IntersectionObserver' in w) {
    d.documentElement.classList.add('edc-js');
    var sel = '.edc .edc-k,.edc .edc-t,.edc .edc-p,.edc .edc-btns,.edc-marque,.edc-card,.edc-chiffre,.edc-art,.edc-liste li,.edc-etapes li,.edc-pouches,.edc .edc-sceau,.edc-carnet__box,.edc-manifeste__icone,.edc-manifeste__sig,.edc-machine__vis';
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    [].forEach.call(d.querySelectorAll(sel), function (el) {
      if (el.parentElement && el.parentElement.closest('.edc-rv')) return;
      var i = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--d', (Math.min(i, 5) * 0.09) + 's');
      el.classList.add('edc-rv');
      io.observe(el);
    });
  }

  /* 2. Manifeste : les mots s'éclairent au fil du défilement */
  var fill = d.querySelector('[data-edc-fill]');
  if (fill && !reduce && !design) {
    var words = fill.textContent.trim().split(/\s+/);
    fill.textContent = '';
    words.forEach(function (m, k) {
      var s = d.createElement('span'); s.className = 'edc-mot'; s.textContent = m;
      fill.appendChild(s); if (k < words.length - 1) fill.appendChild(d.createTextNode(' '));
    });
    var mots = fill.querySelectorAll('.edc-mot');
    fill.classList.add('edc-fill-on');
    onScroll(function () {
      var r = fill.getBoundingClientRect(), vh = w.innerHeight;
      var p = (vh * 0.92 - r.top) / (r.height + vh * 0.3);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * mots.length);
      for (var i = 0; i < mots.length; i++) mots[i].classList.toggle('on', i < n);
    });
  }

  /* 3. Hero : parallaxe des montagnes, neige, incitation au défilement */
  var hero = d.querySelector('[data-edc-hero]');
  if (hero) {
    if (!reduce) {
      onScroll(function () {
        var r = hero.getBoundingClientRect();
        if (r.bottom < 0) return;
        hero.style.setProperty('--p', Math.max(0, Math.min(1, -r.top / r.height)).toFixed(3));
      });
    }
    var suite = hero.querySelector('[data-edc-suite]');
    if (suite) suite.addEventListener('click', function (e) {
      var s = hero.closest('.shopify-section'), n = s && s.nextElementSibling;
      if (n) { e.preventDefault(); n.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }
    });
    var cv = hero.querySelector('.edc-hero__neige');
    if (cv && cv.getContext && !reduce) {
      var ctx = cv.getContext('2d'), W = 0, H = 0, dpr = Math.min(w.devicePixelRatio || 1, 2), fl = [], raf = 0, vis = true;
      var size = function () { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
      var flocon = function (init) { return { x: Math.random() * W, y: init ? Math.random() * H : -8, r: Math.random() * 1.7 + 0.5, v: Math.random() * 0.45 + 0.22, a: Math.random() * 6.28, o: Math.random() * 0.45 + 0.3 }; };
      size();
      var N = W < 750 ? 38 : 85;
      for (var i = 0; i < N; i++) fl.push(flocon(true));
      var frame = function () {
        ctx.clearRect(0, 0, W, H); ctx.fillStyle = '#ffffff';
        for (var i = 0; i < fl.length; i++) {
          var f = fl[i]; f.y += f.v; f.a += 0.008; f.x += Math.sin(f.a) * 0.3;
          if (f.y > H + 6) { fl[i] = flocon(false); continue; }
          ctx.globalAlpha = f.o; ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill();
        }
        raf = (vis && !d.hidden) ? w.requestAnimationFrame(frame) : 0;
      };
      w.addEventListener('resize', size);
      if ('IntersectionObserver' in w) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; if (vis && !raf) raf = w.requestAnimationFrame(frame); }).observe(hero);
      d.addEventListener('visibilitychange', function () { if (!d.hidden && vis && !raf) raf = w.requestAnimationFrame(frame); });
      raf = w.requestAnimationFrame(frame);
    }
  }
  run();
})();